// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}

tr.mat-mdc-header-row {
  height: 46px;
}

#mainList td:not(.mat-mdc-column-status):first-child {
  padding-right: 5px;
}

#mainList td.mat-mdc-column-fullName {
  word-break: break-word;
  padding-right: 12px;
}

#mainList td.mat-mdc-column-creationDate {
  padding-right: 24px;
}

.mat-mdc-form-field {
  font-size: 1.3rem;
  width: 100%;
}

.noResult {
  font-size: 1.5rem;
  color: #111111;
  padding: 10px;
  text-align: center;
}

td.noBorder {
  border-bottom: none;
}

td.mat-mdc-cell:first-of-type, td.mat-mdc-footer-cell:first-of-type, th.mat-mdc-header-cell:first-of-type {
  padding: 10px 0 10px 10px;
}

.mat-greenIcon {
  background: #78c7af !important;
}

.mat-redIcon {
  background: #f07b7e !important;
}

.mat-yellowIcon {
  background: #efce7c !important;
}

.mat-darkGrayIcon {
  background: #666666 !important;
}

.mat-grayIcon {
  background: #cccccc !important;
}

.mat-orangeIcon {
  background: #007566 !important;
}

::ng-deep #mainList thead,
::ng-deep .mainList thead {
  background-color: #111111;
}

::ng-deep #mainList .mat-mdc-header-cell,
::ng-deep .mainList .mat-mdc-header-cell {
  font-size: 1.3rem;
  font-weight: bold;
  background-color: #111111;
  color: #ffffff;
}

::ng-deep #mainList .mat-mdc-sort-header-arrow,
::ng-deep .mainList .mat-mdc-sort-header-arrow {
  color: #ffffff;
}

::ng-deep #mainList td:nth-child(2) {
  padding-right: 10px;
}

::ng-deep #mainList .mat-mdc-mini-fab {
  width: 25px;
  height: 25px;
  color: #ffffff !important;
}

::ng-deep #mainList .mat-mdc-mini-fab .mdc-button__label {
  padding: 0;
  font-size: 1.18rem;
  position: relative;
  top: 0;
  font-weight: bold;
}

::ng-deep #mainList td.mat-mdc-cell:last-of-type,
::ng-deep #mainList td.mat-mdc-footer-cell:last-of-type,
::ng-deep #mainList th.mat-mdc-header-cell:last-of-type {
  padding-right: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/main-list/components/mobile/mobile-main-list/mobile-main-list.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,WAAA;AACJ;;AAEA;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;;EAEI,yBAAA;AACJ;;AAEA;;EAEI,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AACJ;;AAEA;;EAEI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;AACJ;;AAEA;EACI,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,iBAAA;AACJ;;AAEA;;;EAGI,2BAAA;AACJ","sourcesContent":["table {\n    width: 100%;\n}\n\ntr.mat-mdc-header-row {\n    height: 46px;\n}\n\n#mainList td:not(.mat-mdc-column-status):first-child {\n    padding-right: 5px;\n}\n\n#mainList td.mat-mdc-column-fullName {\n    word-break: break-word;\n    padding-right: 12px;\n}\n\n#mainList td.mat-mdc-column-creationDate {\n    padding-right: 24px;\n}\n\n.mat-mdc-form-field {\n    font-size: 1.3rem;\n    width: 100%;\n}\n\n.noResult {\n    font-size: 1.5rem;\n    color: #111111;\n    padding:10px;\n    text-align: center;\n}\n\ntd.noBorder{\n    border-bottom: none;\n}\n\ntd.mat-mdc-cell:first-of-type, td.mat-mdc-footer-cell:first-of-type, th.mat-mdc-header-cell:first-of-type {\n    padding: 10px 0 10px 10px;\n}\n\n.mat-greenIcon {\n    background: #78c7af !important;\n}\n\n.mat-redIcon {\n    background: #f07b7e !important;\n}\n\n.mat-yellowIcon {\n    background: #efce7c !important;\n}\n\n.mat-darkGrayIcon {\n    background: #666666 !important;\n}\n\n.mat-grayIcon {\n    background: #cccccc !important;\n}\n\n.mat-orangeIcon {\n    background: #007566 !important;\n}\n\n::ng-deep #mainList thead,\n::ng-deep .mainList thead {\n    background-color: #111111;\n}\n\n::ng-deep #mainList .mat-mdc-header-cell,\n::ng-deep .mainList .mat-mdc-header-cell {\n    font-size: 1.3rem;\n    font-weight: bold;\n    background-color: #111111;\n    color: #ffffff;\n}\n\n::ng-deep #mainList .mat-mdc-sort-header-arrow,\n::ng-deep .mainList .mat-mdc-sort-header-arrow{\n    color: #ffffff;\n}\n\n::ng-deep #mainList td:nth-child(2) {\n    padding-right: 10px;\n}\n\n::ng-deep #mainList .mat-mdc-mini-fab {\n    width: 25px;\n    height: 25px;\n    color: #ffffff!important;\n}\n\n::ng-deep #mainList .mat-mdc-mini-fab .mdc-button__label {\n    padding: 0;\n    font-size: 1.18rem;\n    position: relative;\n    top: 0;\n    font-weight: bold;\n}\n\n::ng-deep #mainList td.mat-mdc-cell:last-of-type,\n::ng-deep #mainList td.mat-mdc-footer-cell:last-of-type,\n::ng-deep #mainList th.mat-mdc-header-cell:last-of-type {\n    padding-right: 0 !important;\n}\n\n// .mdc-data-table__cell {\n//     padding: 0!important;\n// }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
